import { InMemoryTrackingRepository } from '@/Infrastructure/Tracking'
import { FetchTrackingCommand } from './FetchTrackingCommand'
import { TrackingDTO } from './TrackingDTO'

export class FetchTrackingCommandHandler {
  private repository: InMemoryTrackingRepository
  constructor (repository: InMemoryTrackingRepository) {
    this.repository = repository
  }

  // eslint-disable-next-line
  async handle (command: FetchTrackingCommand): Promise<TrackingDTO[]> {
    const trakings = await this.repository.fetchTrackingBatches(command.procedureId())
    const response: TrackingDTO[] = []
    for (const tracking of trakings) {
      const item = TrackingDTO.fromtracking(tracking)
      response.push(item)
    }
    return response
  }
}
